<script setup>
defineProps({
  size: { type: String, default: "40px" },
});
</script>

<template>
  <div class="spinner" :style="{ width: size, height: size }" />
</template>

<style scoped>
/* Tailwind's animate-spin works but we need a custom border-top-color — kept here intentionally */
.spinner {
  border: 3px solid #e2e8f0;
  border-top-color: #f04e23;
  border-radius: 50%;
  animation: spin 0.7s linear infinite;
}
@keyframes spin { to { transform: rotate(360deg); } }
</style>
